export const environment = {
  production: true,
  buildId: '4031528661924401',
  configFile: 'config.json',
};
